import cookie from 'react-cookie';
import jwt_decode from 'jwt-decode';
import { push } from 'react-router-redux';

import Session from '../Session';

export const SAVE_SESSION = 'SAVE_SESSION';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';

const saveSession = (session) => ({ type: SAVE_SESSION, session });
const sessionLogout = () => ({ type: SESSION_LOGOUT });

const getSessionCookie = () => {
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_SESSION_COOKIE) {
        return process.env.REACT_APP_DEV_SESSION_COOKIE;
    }

    return cookie.load('jwt.payload');
};

const decodeJwtSession = (sessionCookie) => {
    let jwtPayload;

    try {
        jwtPayload = jwt_decode(sessionCookie);
    } catch(e) {
    }

    return new Session(jwtPayload);
};

export const updateSession = (dispatch, getState) => {
    const { session: previousSessionState, session: { isAdmin: wasAdmin = false } } = getState();
    const session = decodeJwtSession(getSessionCookie());

    const loggedOut = (!session.isAuthenticated && previousSessionState.isAuthenticated);

    dispatch(saveSession(session));

    if (loggedOut) {
        dispatch(sessionLogout());

        const loginRedirect = wasAdmin ? '/admin' : '/login';
        dispatch(push(loginRedirect));
    }
};



// WEBPACK FOOTER //
// ./src/actions/session.js